<template lang="pug">
.memberInfo(v-loading="isLoading")
  template(v-if="currentUser")
    .bottons
      template(v-if="currentUser.role !== 'owner'")
        el-button(@click="isShowingManagerEditDialog=true" icon="el-icon-edit" size="mini")
        el-button(@click="isShowingManagerDeleteDialog=true" icon="el-icon-delete" size="mini" type="danger")

    .profile
      el-upload.avatar-uploader(:on-change="addedUserThumb" action="" :auto-upload="false" :show-file-list="false" :on-success="successUpload" :before-upload="beforeUpload")
        img(:src="profileImage" @mouseover="isMouseOveredDefaultProfImage=true" @mouseleave="isMouseOveredDefaultProfImage=false" class="thumb")
      span.base.name {{ currentUser.name }}
      span.base.email {{ currentUser.email }}
      span.base.note {{ currentUser.description }}
      span.base.is-active {{ $t('Members.condition')}}
        el-tag.active(v-if="currentUser.is_active === true" size="mini" type="success") {{ $t('Members.enabled')}}
        el-tag.inactive(v-else size="mini" type="danger") {{ $t('Members.disabled')}}

    .groups
      h2 {{ $t('Members.title01') }}
        span.count {{ managedGroups.length }}
      el-table#groups(:data="managedGroups" cell-class-name="el-table-cell" row-class-name="el-table-row" header-row-class-name="el-table-header")
        el-table-column(prop="name" :label="$t('Members.group_name')" sortable="")
        el-table-column(v-if="currentUser.role === 'owner'" prop="manager.name" :label="$t('Cuona.Group.manager')" sortable="")
        el-table-column(prop="description" :label="$t('Members.note')")
        el-table-column(width="250px" align="center" prop="function" :label="$t('Members.functions')")
          template(slot-scope="props")
            //- TODO: dirty hack
            el-button(type="text" size="mini" @click="openUpdateDialog(props.row.id, props.row.manager_id || props.row.manager.id)") {{ $t('Members.changeManager') }}

    //- 削除ダイアログ
    el-dialog(:title="$t('Members.title02')" :visible.sync="isShowingManagerDeleteDialog")
      span(v-if="0 < currentUser.groups.length") {{ $t('Members.description01') }}
      span(v-else) {{ $t('Members.description01', {user: currentUser.name}) }}
      span.dialog-footer(slot="footer")
        template(v-if="0 < currentUser.groups.length")
          el-button(@click="isShowingManagerDeleteDialog=false") {{ $t('Members.close') }}
        template(v-else)
          el-button(@click="isShowingManagerDeleteDialog=false" :disabled="isLoading") {{ $t('Members.cancel') }}
          el-button(type="danger" @click="deleteManager" :disabled="isLoading") {{ $t('Members.delete') }}

    //- 変更ダイアログ
    el-dialog(:title="$t('Members.title05')" :visible.sync="isShowingManagerEditDialog")
      p.condition {{ $t('Members.condition')}}
        span.active(v-if="currentUser.is_active === true" size="mini" type="success") {{ $t('Members.enabled')}}
        span.inactive(v-else size="mini" type="danger") {{ $t('Members.disabled')}}
      span(v-if="currentUser.is_active" v-html="$t('Members.description04')")
      span(v-else v-html="$t('Members.description05')")
      span.dialog-footer(slot="footer")
        el-button(@click="isShowingManagerEditDialog=false" :disabled="isLoading") {{ $t('Members.close') }}
        el-button(type="danger" @click="editManager" :disabled="isLoading") {{ $t('Members.edit') }}

    //- 管理者変更ダイアログ
    el-dialog(:title="$t('Members.changeManager')" :visible.sync="isShowMemberUpdateDialog")
      el-form(label-position="left" :rules="rules" label-width="120px" ref="dialogForm" :model="dialogForm" v-loading="isLoading")
        el-form-item(:label="$t('Cuona.Group.manager')" prop="managerId")
          el-select(v-model="dialogForm.managerId" :placeholder="$t('Cuona.Group.choice')")
            el-option(v-for="(user, index) in ownerAndManagers" :label="user.name" :value="user.id" :key="index")
      span.dialog-footer(slot="footer")
        el-button(@click="isShowMemberUpdateDialog=false" :disabled="isLoading") {{ $t('Members.cancel') }}
        el-button(type="primary" @click="updateGroupManager" :disabled="isLoading") {{ $t('Members.edit') }}
</template>

<script>
import UserApi from '@/api/user'
import GroupApi from '@/api/group'
export default {
  data () {
    return {
      isLoading: false,
      ownerAndManagers: [],
      currentUser: null,
      isMouseOveredDefaultProfImage: false,
      images:{
        cuona: require('@/assets/cuona_small_logo.svg'),
        arrow: require('@/assets/arrow.svg')
      },
      isShowingManagerDeleteDialog: false,
      isShowingManagerEditDialog: false,
      isShowMemberUpdateDialog: false,
      selectService: null,
      baseFlg: null,
      changeForm: {
        id: null,
        serivce_key: null
      },
      dialogForm: {
        managerId: null,
        groupId: null
      },
      rules: {
        manager: [
          { required: true, message: this.$t('Members.message03'), trigger: 'change' }
        ]
      }
    }
  },
  computed: {

    // 現在表示中のメンバーのプロフ画像
    profileImage: function() {
      if(this.isMouseOveredDefaultProfImage && !this.currentUser.thumb_url) {
        return require("@/assets/default_hover.svg")
      }
      return this.currentUser.thumb_url || require("@/assets/default.svg")
    },

    managedGroups: function() {
      const that = this;
      return this.currentUser.groups.filter((group) => {
        return group.manager_id === that.currentUser.id;
      });
    }
  },
  mounted() {
    this.getOwnerAndManagers();
  },
  watch : {
    currentUser : function() {
      if(this.currentUser) {
        this.$store.commit('setLastBreadcrumb', this.currentUser.name);
        this.setPageTitle(this.currentUser.name + " : " + this.$t('submenus.member'));
      }
    },
  },
  methods: {

    getOwnerAndManagers: function (){
      this.isLoading = true;
      const that = this;
      Promise.all([UserApi.getUser(), UserApi.getManagers()])
        .then((values) => {
          that.ownerAndManagers = values[1];
          that.ownerAndManagers.unshift(values[0]);
          that.currentUser = that.ownerAndManagers.find(function(user) {
            return user.id === Number(that.$route.params.id);
          });
        })
        .catch((error) => {
          this.$message({
            showClose: true,
            message: this.$t('user.failed_get'),
            type: 'error'
          });
        })
        .finally(() => { this.isLoading = false; });
    },

    // ユーザー画像を選択した時
    addedUserThumb: function (file, fileList) {
      this.isLoading = true;
      const that = this;
      this.fileToDataUri(file.raw).then(function(dataUri){
        const params = {
          user_id: that.currentUser.id,
          thumb: dataUri
        };
        UserApi.updateUserThumb(params)
          .then((user) => {
            if(user.role === 'owner') that.$store.commit('setUser', user);  // for header
            that.currentUser = user;
            that.$message({
              showClose: true,
              message: that.$t('Members.message04'),
              type: 'success'
            })
          })
          .catch((error) => {
            that.$message({
              showClose: true,
              message: that.$t('Members.message08'),
              type: 'error'
            })
          }).finally(() => { that.isLoading = false; });
      })
    },

    // fileをDataUriに変換
    fileToDataUri: function(file) {
      return new Promise(function (resolve) {
        const reader = new FileReader();
        reader.addEventListener('load', function() {
          resolve(reader.result);
        });
        reader.readAsDataURL(file);
      });
    },

    //アップロードが終わった時
    successUpload: function(res, file) {
      this.currentUser.thumb_url = URL.createObjectURL(file.raw)
    },

    // アップロード前のチェック
    beforeUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      const isLt10M = file.size / 1024 < 1024;

      if (!isJPG && !isPNG) {
        this.$message.error(this.$t('Members.message05'));
      }
      if (!isLt10M) {
        this.$message.error(this.$t('Members.message06'));
      }
      return (isJPG || isPNG) && isLt10M;
    },

    selectServiceImage: function() {
      switch(this.selectService){
        case "Favor" : return this.images.favor;
        case "Cuona Manager" : return this.images.cuona;
      }
    },

    // グループ更新ダイアログを開く
    openUpdateDialog: function(groupId, managerId) {
      this.dialogForm.groupId = groupId
      this.dialogForm.managerId = managerId
      this.isShowMemberUpdateDialog = true
    },

    // メンバーの編集
    editManager: function() {
      this.isLoading = true;
      const payload = {
        id: this.currentUser.id,
        params: {
          manager_blocked: this.currentUser.is_active
        }
      }
      UserApi.updateManager(payload)
        .then((manager) => {
          this.currentUser = manager;
          this.isShowingManagerEditDialog = false
          const statusTxt = this.currentUser.is_active ? this.$t('Members.enabled') : this.$t('Members.disabled')
          this.$message({
            showClose: true,
            message: this.$t('Members.message07',{status: statusTxt}),
            type: 'success'
          })
        })
        .catch((error) => {
          this.$message({
            showClose: true,
            message: this.$t('Members.message08'),
            type: 'error'
          })
        }).finally(() => { this.isLoading = false; });
    },

    // メンバーの削除
    deleteManager: function() {
      this.isLoading = true;
      UserApi.deleteManager(this.currentUser.id)
        .then((manager) => {
          this.$router.push('/member');
          this.$message({
            showClose: true,
            message: this.$t('user.success_delete'),
            type: 'success'
          });
        })
        .catch((error) => {
          this.$message({
            showClose: true,
            message: this.$t('user.failed_delete'),
            type: 'error'
          })
        }).finally(() => { this.isLoading = false; });
    },

    showTitle: function() {
      return this.baseFlg == true ? this.$t('Members.changeLogin') : this.$t('Members.changeUnLogin');
    },

    toggleEnabled: function() {
      return this.baseFlg == true ? this.$t('Members.enabled') : this.$t('Members.disabled');
    },

    //サービスの有効数
    enabledCount: function() {
      var count = 0;
      this.currentUser.services.forEach(function(service){
        if(service.is_enabled == true){
          count++;
        }
      })
      return count
    },

    updateGroupManager: function(){
      this.$refs['dialogForm'].validate((valid) => {
        if (valid) {
          this.isLoading = true;
          const payload = {
            groupId: this.dialogForm.groupId,
            params: {
              group: {
                manager_id: this.dialogForm.managerId
              }
            }
          };
          GroupApi.updateGroup(payload)
            .then((updatedGroup) => {
              if(this.currentUser.id !== updatedGroup.manager.id) {
                this.currentUser.groups = this.currentUser.groups.filter(function(currentGroup) {
                  return currentGroup.id !== updatedGroup.id;
                });
              }
              this.isShowMemberUpdateDialog = false;
              this.$message({
                showClose: true,
                message: this.$t('Cuona.Group.message05'),
                type: 'success'
              });
            })
            .catch((error) => {
              this.$message({
                showClose: true,
                message: this.$t('Cuona.Group.failed_update'),
                type: 'error'
              });
            }).finally(() => { this.isLoading = false; });
        } else {
          return false;
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables.scss";

.groups, .canLoggedin {
  border-top: 1px solid $border;
  h2 {
    font-size: 16px;
    font-weight: normal;
    color: #333;
    margin: 30px 0 20px 40px;
  }

  .el-table ::v-deep {
    padding: 0 40px 5px 40px;
    margin-bottom: 40px;

    .el-table-header th {
      padding: 10px 0 0 0;
      font-weight: normal;
      font-size: 12px;

      .cell {
        padding: 0 0 0 20px;
      }
    }
    td.el-table-cell {
      font-size: 13px;
      .cell {
        padding: 0 0 0 20px;
      }
    }
  }
  .el-table:before {
    display: none;
  }
}
.canLoggedin {
  .el-table ::v-deep {
    padding: 0 40px;
  }
}

.memberInfo {
  min-height: 20vh;
  background: #FFF;
  border-radius: 5px;
  margin: 40px;
  padding: 0;
  border: 1px solid $border;

  .profile {
    margin: 20px 0;
    text-align: center;
  }

  img.thumb {
    width: 100px;
    height: 100px;
    object-fit: cover;
    border-radius: 50px;
    margin-bottom: 3px;
  }

  span.base {
    display: block;
    font-size: 14px;

    .el-tag {
      margin: 3px 0;
    }
    &.is-active {
      font-size: 13px;
      margin-top: 10px;
    }
    &.email {
      font-size: 13px;
    }
  }
}

.process {
  width: 300px;
  margin: 20px auto;
  img.thumb {
    width: 100px;
    height: 100px;
    object-fit: cover;
    border-radius: 50px;
  }
  img {
    vertical-align: middle;
  }
  img.arrow {
    height: 50px;
    margin: 0 20px;
  }
  span.service {
    display: inline-block;
    width: 96px;
    height: 96px;
    border-radius: 50px;
    border: 2px solid $border;
    text-align: center;
    line-height: 98px;
    img {
      height: 50px;
    }
  }
}

p.condition {
  margin: 0 0 20px 0;

  span.active {
    color: $green;
    font-weight: bold;
  }
  span.inactive {
    color: $danger;
    font-weight: bold;
  }
}

.dialog-center-footer {
  display: block;
  text-align: center;

  .el-button {
    width: 200px;
  }
}

p.description {
  font-size: 13px;
  text-align: center;
}

.bottons {
  display: flex;
  justify-content: flex-end;
  margin: 10px 10px 0 0;
}

span.count {
  display: inline-block;
  text-align: center;
  background: $border;
  min-width: 20px;
  padding: 1px 6px;
  font-size: 12px;
  border-radius: 15px;
  margin-left: 8px;
}

</style>
